import htmx from 'htmx.org';
window.$(window).on('load', function () {
    window.$('.main-nav-trigger').on('click', function () {
        var ifs = window.$(this).attr('aria-expanded')
        console.log(ifs)

        if (ifs === 'false') {
            window.$(this).addClass('active')
        } else {
            window.$(this).removeClass('active')
        }
    })
    var ulHeight = window.$("ul.submenu").height()

    var i

    window.$('.nav-trigger').on('click', function () {
        i = 1

        if (i < 3) {
            setTimeout(function () {
                window.$(this).trigger('click')

                i++

            }, 20)
        } else {
            i = 0
        }
    })

    window.$("#instagramButton").click();
    setTimeout(function () {

    }, 500)

    console.log(ulHeight)
    window.$(".dropdown-container button.dropdown-open").find('i.fa-chevron-up').hide()


    if (window.$(window).width() > 991) {

        window.$("li.has-submenu > a").on('click', function (e) {
            e.preventDefault()
            // Close all other submenus
            window.$("li.has-submenu > a").not(window.$(this)).removeClass("active");
            // Toggle the clicked submenu
            window.$(this).toggleClass("active");

            window.$(".subMenu").not(window.$(this).siblings(".subMenu")).removeClass("show");
            // Toggle the clicked submenu
            window.$(this).siblings(".subMenu").toggleClass("show");
        })

        window.$(window).on("scroll", function () {
            window.$(".subMenu").removeClass("show");
        });

        window.$('.main-nav li.nav-li').on('mouseenter', function () {
            window.$('ul.submenu').removeClass('active')
            window.$('.dropdown-container').attr('data-click-state', 0);
            window.$(".dropdown-container").removeClass('active')
            window.$('.dropdown-container').find('i.fa-chevron-right').show()
            window.$('.dropdown-container').find('i.fa-chevron-left').hide()

        })
        window.$(".main-nav").on('mouseleave', function () {
            window.$('ul.submenu').removeClass('active')
            window.$('.dropdown-container').attr('data-click-state', 0);
            window.$(".dropdown-container").removeClass('active')
            window.$('.dropdown-container').find('i.fa-chevron-right').show()
            window.$('.dropdown-container').find('i.fa-chevron-left').hide()

        })
        window.$(".dropdown-container").on('mouseenter', function () {
            window.$(this).attr('data-click-state', 1);
            window.$(this).find('i.fa-chevron-right').hide()
            window.$(this).find('i.fa-chevron-left').show()
            window.$(this).next(".submenu").addClass('active')
            window.$(this).addClass('active')
        })

        window.$("ul.submenu").on('mouseleave', function () {
            console.log('left li')
            window.$('ul.submenu').removeClass('active')
            window.$('.dropdown-container').attr('data-click-state', 0);
            window.$(".dropdown-container").removeClass('active')
            window.$('.dropdown-container').find('i.fa-chevron-right').show()
            window.$('.dropdown-container').find('i.fa-chevron-left').hide()

        })
    }
    if (window.$(window).width() < 991) {

        window.$(".dropdown-container button.dropdown-open").on('click', function () {
            console.log
            if (window.$(this).attr('data-click-state') == 0) {
                window.$(this).attr('data-click-state', 1);
                window.$(this).find('i.fa-chevron-down').hide()
                window.$(this).find('i.fa-chevron-up').show()
                window.$(this).parent().next("ul.submenu").addClass('active')
                window.$(this).parent().addClass('active')

            } else {
                window.$(this).attr('data-click-state', 0);
                window.$("ul.submenu").removeClass('active')
                window.$(this).find('i.fa-chevron-down').show()
                window.$(this).find('i.fa-chevron-up').hide()
                window.$(this).parent().removeClass('active')
            }

        })
    }
    let headerHeight = window.$('header.header').height();
    let lastScrollTop = 0;

    window.$("header.header").addClass("stick");
    window.$("body").css("padding-top", headerHeight);
    window.$(window).on("scroll", function () {
        let currentScroll = window.$(this).scrollTop();

        if (currentScroll > lastScrollTop) {
            window.$("header.header").addClass("short");
        } else if (currentScroll < lastScrollTop) {
            window.$("header.header").removeClass("short");
        }

        lastScrollTop = currentScroll;
    });


})
window.addEventListener('DOMContentLoaded', function () {
    let header = document.querySelector('header.header');
    let headerHeight = header.offsetHeight;
    let mobileMenu = document.querySelector('.mobile-menu');
    mobileMenu.style.top = (headerHeight-3) + 'px';
    mobileMenu.style.height = 'calc(100vh - ' + headerHeight + 'px)';
    let navTrigger = document.querySelector('.menuBtn');

    let isOpen = false;
    navTrigger.addEventListener('click', function () {

        isOpen = !isOpen;

        document.body.style.overflow = isOpen ? 'hidden' : '';

        mobileMenu.classList.toggle('showed');
        navTrigger.classList.toggle('active');
    });
});


let productFilters = () => {
    if (document.querySelector('.categories') == null) {
        return;
    }
    let filters = document.querySelector('.categories').querySelectorAll('.category');
    let products = document.querySelector('.products').querySelectorAll('.product-item');

    products.forEach((product) => {
        // product.classList.add('fade', 'show');
    })

    filters.forEach((filter) => {
        filter.addEventListener('click', function () {
            let thisCategory = this.getAttribute('data-show');

            filters.forEach((filter) => {
                filter.classList.remove('open');
            })
            this.classList.add('open');

            if (thisCategory == 'all') {
                products.forEach((product) => {
                    product.classList.remove('fade');
                    setTimeout(function () {
                        product.classList.remove('d-none');
                    })
                }, 300)
            } else {
                products.forEach((product) => {
                    // product.classList.remove('show');
                    if (product.getAttribute('data-item') != thisCategory) {
                        product.classList.add('fade');
                        setTimeout(function () {
                            product.classList.add('d-none');
                        }, 300)

                    } else {
                        product.classList.remove('fade');
                        setTimeout(function () {
                            product.classList.remove('d-none');
                        }, 300)
                        // product.classList.remove('hidden');
                    }
                })
            }
        })
    })
}

import Swiper from 'swiper';
import {
    Navigation,
    Pagination
} from 'swiper/modules';
// import Swiper and modules styles

const link = document.createElement('link');
link.rel = 'stylesheet';
link.href = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css';
document.head.appendChild(link);

// import 'swiper/swiper.min.css';
// import 'swiper/modules/navigation/navigation.min.css';
// import 'swiper/modules/pagination/pagination.min.css';




window.addEventListener('DOMContentLoaded', function () {
    var swiper = new Swiper(".thumbSlider", {

        modules: [Navigation, Pagination],
        spaceBetween: 10,
        slidesPerView: 4,
        freeMode: true,
        watchSlidesProgress: true,
    });
    var swiper2 = new Swiper(".mainSlider", {
        spaceBetween: 10,
        modules: [Navigation, Pagination],
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        thumbs: {
            swiper: swiper,
        },
    });

    if (window.innerWidth < 1024) {
    }

    productFilters();
})

const cardSliderSwiper = () => {
    document.querySelectorAll('.cardSlider').forEach((el) => {
        if (!el) return; // ✅ Guard against null
        
        // Destroy existing Swiper instance if it exists
        if (el.swiper) {
            el.swiper.destroy(true, true);
        }

        new Swiper(el, {
            modules: [Navigation, Pagination],
            spaceBetween: 20,
            slidesPerView: 1,
            breakpoints: {
                991: {
                    slidesPerView: 1.5,
                },
            },
            navigation: {
                nextEl: el.parentElement.querySelector('.swiper-button-next'),
                prevEl: el.parentElement.querySelector('.swiper-button-prev'),
            },
        });
    });
};

const adujstContainerWidth = () => {
    const container = document.querySelector('.container');
    console.log("🚀 ~ adujstContainerWidth ~ container:", container)
    if (container && window.innerWidth > 991) {
        // find width of first container.
        const firstContainer = document.querySelector('.container');
        if (firstContainer) {
            //find offset of first container.
            let offset = firstContainer.offsetLeft;
            
            offset = offset < 17  ? 16 : offset;
            
            console.log("🚀 ~ adujstContainerWidth ~ offset:", offset)

            // set css var 'html { --containerOffset }
            document.documentElement.style.setProperty('--container-offset', offset + 'px');
        }
    }
}

// doc load and resize
adujstContainerWidth
window.addEventListener('load', adujstContainerWidth);
window.addEventListener('load', cardSliderSwiper);
window.addEventListener('resize', adujstContainerWidth);
window.addEventListener('resize', cardSliderSwiper);

const videoLoad = () => {
    const containers = document.querySelectorAll('.video-block');

    console.log("🚀 ~ videoLoad ~ containers:", containers)


    containers.forEach(container => {
        const video = container.querySelector('video');
        const audio = container.querySelector('audio');
        const img = container.querySelector('img');
        const iframe = container.querySelector('iframe');

        // Handle video swap with img placeholder
        if (video && img) {
            video.classList.add('hidden');

            const swapToVideo = () => {
                img.classList.add('hidden');
                video.classList.remove('hidden');
                console.log('video loaded');

                const playPromise = video.play();
                if (playPromise !== undefined) {
                    playPromise.catch(() => {
                        video.muted = true;
                        video.play();
                    });
                }
                video.classList.remove('hidden');
                video.muted = true;        // ← set BEFORE play()
                video.playsInline = true;  // ← add this too
                console.log('video loaded');
                video.play().catch(err => {
                    console.log('Autoplay blocked:', err);
                });
            };

            if (video.readyState >= 3) {
                swapToVideo();
            } else {
                video.addEventListener('canplay', swapToVideo, { once: true });
                console.log('video not loaded');
            }
        }

        // Handle iframe (YouTube/Vimeo) - hide img once iframe is ready

        
        console.log("🚀 ~ videoLoad ~ iframe:", iframe)
        if (iframe) {
            console.log("🚀 ~ videoLoad ~ iframe:", iframe)
            iframe.classList.add('hidden');
            iframe.addEventListener('load', () => {
                img?.classList.add('hidden');
                iframe.classList.remove('hidden');
                console.log('iframe loaded');
            });
            if (iframe) {
                const actualSrc = iframe.dataset.src; // store src in data-src in Twig
                iframe.removeAttribute('src');        // no src = doesn't load on page load

                iframe.src = actualSrc;             // now it loads, autoplay fires fresh
                iframe.addEventListener('load', () => {
                    if  (img) {
                        img.classList.add('hidden');
                    }
                    // iframe.classList.remove('hidden');
                    console.log('iframe loaded');
                });
                window.addEventListener('load', () => {

                });
            }
        }
        // Handle audio player button
        if (audio) {
            audio.classList.remove('hidden');

            const btn = document.createElement('button');
            btn.innerHTML = '▶ Play Audio';
            btn.classList.add('audio-btn');

            btn.addEventListener('click', () => {
                if (audio.paused) {
                audio.play();
                btn.innerHTML = '⏸ Pause Audio';
                } else {
                audio.pause();
                btn.innerHTML = '▶ Play Audio';
                }
            });

            audio.addEventListener('ended', () => {
                btn.innerHTML = '▶ Play Audio';
            });

            container.appendChild(btn);
        }
    });
};

document.addEventListener('DOMContentLoaded', videoLoad);

const accordians = () => {
    let accordianElements = document.querySelectorAll('.accordians');

    accordianElements.forEach((wrapper) => {
        const items = wrapper.querySelectorAll('.group');

        items.forEach((item) => {
            const trigger = item.querySelector('.question');
            const content = item.querySelector('.answer');
            const chevron = item.querySelector('.chevron'); // ✅

            content.style.overflow = 'hidden';
            content.style.height = '0px';
            content.style.transition = 'height 0.3s ease';

            trigger.addEventListener('click', () => {
                const isOpen = item.classList.contains('is-open');

                // Close all others
                items.forEach((other) => {
                    if (other !== item && other.classList.contains('is-open')) {
                        const otherContent = other.querySelector('.pt-2');
                        const otherChevron = other.querySelector('.chevron'); // ✅
                        other.classList.remove('is-open');
                        otherContent.style.height = '0px';
                        if (otherChevron) otherChevron.style.transform = 'rotate(0deg) translateY(-50%)'; // ✅
                    }
                });

                // Toggle current
                if (isOpen) {
                    item.classList.remove('is-open');
                    content.style.height = '0px';
                    if (chevron) chevron.style.transform = 'rotate(0deg) translateY(-50%)'; // ✅
                } else {
                    item.classList.add('is-open');
                    content.style.height = content.scrollHeight + 'px';
                    if (chevron) chevron.style.transform = 'rotate(180deg) translateY(-50%)'; // ✅
                }
            });

            // Add chevron as additional trigger
            if (chevron) {
                chevron.addEventListener('click', () => {
                    trigger.click();
                });
            }
        });
    });
};

document.addEventListener('DOMContentLoaded', accordians);
const tabs = () => {
  document.querySelectorAll('.tabs').forEach(tabs => {
    const navs = tabs.querySelectorAll('[data-tab]');
    const bodies = tabs.querySelectorAll('[data-tab-body]');

    const openTab = (target) => {
      navs.forEach(n => n.classList.remove('bg-black', 'text-primary'));
      const activeNav = tabs.querySelector(`[data-tab="${target}"]`);
      if (activeNav) activeNav.classList.add('bg-black', 'text-primary');

      bodies.forEach(body => {
        const isTarget = body.getAttribute('data-tab-body') === target;
        body.classList.toggle('hidden', !isTarget);
        body.classList.toggle('show', isTarget);
        body.classList.toggle('active', isTarget);
      });
    };

    navs.forEach(nav => {
      nav.addEventListener('click', e => {
        e.preventDefault();
        if (nav.getAttribute('data-tab-disabled') === '1') return;
        openTab(nav.getAttribute('data-tab'));
      });
    });

    // Open from URL hash on load
    const hash = window.location.hash.replace('#nav-', '');
    const matchedNav = hash && tabs.querySelector(`[data-tab="${hash}"]:not([data-tab-disabled="1"])`);
    if (matchedNav) {
      openTab(hash);
    }
  });
};

document.addEventListener('DOMContentLoaded', tabs);


const initRotatingText = () => {
    document.querySelectorAll('.rotatingText').forEach(block => {
        const rotating = block.querySelector('.rotating');
        const items = [...rotating.children];
        let current = 0;

        items.forEach((item, i) => {
            item.style.position = 'absolute';
            item.style.opacity = i === 0 ? '1' : '0';
            item.style.transform = i === 0 ? 'translateY(0)' : 'translateY(100%)';
            item.style.transition = 'opacity 0.2s ease, transform 0.5s ease';
        });

        rotating.style.position = 'relative';

        setInterval(() => {
            const next = (current + 1) % items.length;

            // Reset next item below without transition
            items[next].style.transition = 'none';
            items[next].style.transform = 'translateY(100%)';
            items[next].style.opacity = '0';

            // Force reflow so the reset applies before transition kicks in
            items[next].offsetHeight;

            // Now animate both
            items[next].style.transition = 'opacity 0.2s ease, transform 0.5s ease';
            items[current].style.opacity = '0';
            items[current].style.transform = 'translateY(-100%)';
            items[next].style.opacity = '1';
            items[next].style.transform = 'translateY(0)';

            current = next;
        }, 1500);
    });
};

document.addEventListener('DOMContentLoaded', initRotatingText);

import { lazyLoad } from 'unlazy';


window.addEventListener('DOMContentLoaded', () => {
    lazyLoad('img[data-lazy-load]')

    const btn = document.querySelector('a.another-product-button');
    if (btn) {
        btn.addEventListener('click', () => {
            // XHR interceptor to watch for successful cart widget responses
            (() => {
                const originalXHR = window.XMLHttpRequest;
                
                const newXHR = () => {
                    const xhr = new originalXHR();
                    const originalOpen = xhr.open.bind(xhr);
                    const originalSend = xhr.send.bind(xhr);
                    
                    let requestUrl = '';
                    
                    xhr.open = (method, url, async, user, password) => {
                        requestUrl = url;
                        return originalOpen(method, url, async, user, password);
                    };
                    
                    xhr.send = (data) => {
                        const originalOnReadyStateChange = xhr.onreadystatechange;
                        
                        xhr.onreadystatechange = () => {
                            if (xhr.readyState === 4 && xhr.status === 200) {
                                try {
                                    const responseText = xhr.responseText;
                                    const responseData = JSON.parse(responseText);
                                    

                                    
                                    console.log("🚀 ~ newXHR ~ responseData.d:", responseData)
                                    if (requestUrl.includes('SetUserCartIdentifier') && 
                                    responseData && responseData.d && responseData.d.IsError === false) {
                                        const btn = document.querySelector('a.another-product-button');

                                        console.log("🚀 ~ newXHR ~ btn:", btn)

                                        if (btn) {
                                            btn.textContent = 'added to cart';
                                        }
                                    }
                                } catch (e) {
                                    // Not JSON or doesn't match expected format, ignore
                                }
                            }
                            
                            if (originalOnReadyStateChange) {
                                originalOnReadyStateChange();
                            }
                        };
                        
                        return originalSend(data);
                    };
                    
                    return xhr;
                };
                
                newXHR.prototype = originalXHR.prototype;
                window.XMLHttpRequest = newXHR;
            })();
        });
    }
})

